// Traduções para navegação - Português (Brasil)
export const navigationPt = {
  // Links da barra de navegação
  links: {
    home: 'Início',
    vehicles: 'Veículos',
    buyDirect: 'Compra Direta',
    consignments: 'Consignação',
    financing: 'Financiamento',
    weSearchForYou: 'Buscamos para você',
    contact: 'Fale conosco',
    book: 'Agendar visita',
  },

  // Breadcrumbs
  breadcrumbs: {
    home: 'Início',
    vehicles: 'Veículos',
    vehicleDetails: 'Detalhes do veículo',
    contact: 'Contato',
    financing: 'Financiamento',
    consignments: 'Consignação',
    buyDirect: 'Compra direta',
    weSearchForYou: 'Buscamos para você',
  },

  // Botões
  buttons: {
    menu: 'Menu',
    close: 'Fechar',
    back: 'Voltar',
    home: 'Ir para o início',
  },
};
